import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../common/components/Dialog';
import { Button } from 'react-bootstrap';
import NewSessionDateForm from './NewSessionDateForm';
import RemoteSubmitButton from '../../common/components/formControls/RemoteSubmitButton';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui'
import { WorkshopSessionTimes } from './actions';

class NewSessionDateDialog extends Component {
    constructor(props) {
        super(props);
    }

    dialogConfig() {
        const { t, onCancel } = this.props;

        return {
            header: t('Workshop_Add_Date'),
            body: this.renderBody(),
            onHide: onCancel,
            footer: this.renderFooter()
        };
    }

    renderBody() {
        const { onConfirm, weekId } = this.props;
        return <NewSessionDateForm onSubmit={onConfirm} initialValues={{
            weekId, 
            morningStartTime: ui.adjustDate(WorkshopSessionTimes.MorningStartTime, 0, 0),
            morningEndTime: ui.adjustDate(WorkshopSessionTimes.MorningEndTime, 0, 0),
            afternoonStartTime: ui.adjustDate(WorkshopSessionTimes.AfternoonStartTime, 0, 0),
            afternoonEndTime: ui.adjustDate(WorkshopSessionTimes.AfternoonEndTime, 0, 0)               
            }} />;
    }

    renderFooter() {
        const { onCancel, t } = this.props;

        const closeBtn = <Button key='close' onClick={onCancel}>{t('Common_Close')}</Button>;
        const confirmBtn = <RemoteSubmitButton key='save' style='primary' formName='newSessionDate' label={t('Common_Save')} />;

        return [closeBtn, confirmBtn];
    }

    render() {
        const { show, block, unblock } = this.props;
        const dialogConfig = this.dialogConfig();
        return <Dialog config={dialogConfig} show={show} block={block} unblock={unblock} />;
    }
}

NewSessionDateDialog.propTypes = {
    show: PropTypes.bool,
    to: PropTypes.array,
    block: PropTypes.oneOfType([
        PropTypes.instanceOf(RegExp),
        PropTypes.string,
        PropTypes.array,
        PropTypes.func
    ]),
    unblock: PropTypes.oneOfType([
        PropTypes.instanceOf(RegExp),
        PropTypes.string,
        PropTypes.array,
        PropTypes.func
    ]),
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired
};

export default withTranslation()(NewSessionDateDialog);